import { render } from "./CopyLink.vue?vue&type=template&id=77cf262a&scoped=true"
import script from "./CopyLink.vue?vue&type=script&lang=js"
export * from "./CopyLink.vue?vue&type=script&lang=js"

import "./CopyLink.vue?vue&type=style&index=0&id=77cf262a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77cf262a"]])

export default __exports__